// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IAddressType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    mailingPriority: number;
    sortOrder: number;
    active: boolean;
}

export class AddressType implements IAddressType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public mailingPriority: number;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Physical AddressType
	**/
    get Physical(): IAddressType {
        return this.FromId(1);
    }
    /**
		Returns Mailing AddressType
	**/
    get Mailing(): IAddressType {
        return this.FromId(3);
    }
    /**
		Returns One Time Mailing AddressType
	**/
    get OneTimeMailing(): IAddressType {
        return this.FromId(4);
    }
    /**
		Returns Domicile AddressType
	**/
    get Domicile(): IAddressType {
        return this.FromId(2);
    }
    /**
		Returns Motor Carrier Mailing AddressType
	**/
    get MotorCarrierMailing(): IAddressType {
        return this.FromId(7);
    }
    /**
		Returns Correspondence AddressType
	**/
    get Correspondence(): IAddressType {
        return this.FromId(5);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Physical', displayValue: 'Physical', description: 'Residential address for the customer', mailingPriority: 1, sortOrder: 1, active: true });
        this._dictionary.add('3', { id: 3, value: 'Mailing', displayValue: 'Mailing', description: 'Mailing address for the customer', mailingPriority: 1, sortOrder: 2, active: true });
        this._dictionary.add('4', { id: 4, value: 'OneTimeMailing', displayValue: 'One Time Mailing', description: 'One Time Mailing', mailingPriority: 1, sortOrder: 3, active: true });
        this._dictionary.add('2', { id: 2, value: 'Domicile', displayValue: 'Domicile', description: 'Domicile address for the vehicle', mailingPriority: 1, sortOrder: 4, active: true });
        this._dictionary.add('7', { id: 7, value: 'MotorCarrierMailing', displayValue: 'Motor Carrier Mailing', description: 'Motor Carrier Mailing', mailingPriority: 0, sortOrder: 6, active: true });
        this._dictionary.add('5', { id: 5, value: 'Correspondence', displayValue: 'Correspondence', description: 'Correspondence Address Use Only', mailingPriority: 0, sortOrder: 99999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IAddressType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IAddressType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IAddressType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IAddressType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IAddressType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
